<div>
  @if (tulokset | async; as asiakkaat) {
    <div>
      <div class="light-blue-text" style="font-size: 40px; margin-left: 40px; margin-bottom: 20px; line-height: 60px; margin-top: 25px">Jaettavat asiakkaat</div>
      @if (asiakkaat.length) {
        <table>
          <tr>
            <th></th>
            <th>Nimi</th>
            <th>Y-tunnus</th>
            <th>Hinta</th>
            <th>Muistiinpanot</th>
          </tr>
          @for (asiakas of asiakkaat; track asiakas) {
            <tr [class]="asiakas.luokat">
              <td>
                @if (asiakas.bsh) {
                  <i title="Sopimus hyväksymättä" class="fa fa-pencil-square" style="font-size: 20px; padding: 1px; color: red"></i>
                }
              </td>
              <td>
                <a [routerLink]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'" [href]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'">{{ asiakas.n }}</a>
              </td>
              <td>{{ asiakas.y }}</td>
              <td>{{ asiakas.h }}</td>
              <td class="sales-muistiinpanot" (click)="muokkaaMuistiinpanoja($event, asiakas)">{{ asiakas.m }}</td>
            </tr>
          }
        </table>
      } @else {
        <div style="padding: 3em">Myynnin listalta ei löytynyt yhtään asiakasta.</div>
      }
    </div>
  }
</div>
